// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Empty_wrapper__1yJBb","title":"Empty_title__3yvip","sub_title":"Empty_sub_title__33LDP"};